<template>
    <div class="contract">
        <img class="bgImg" :src="bg" alt="">
        <div v-if="!phone" class="btn" id="postMessage" @click="viewPage()">返 回 首 页</div>
    </div>
</template>
<script>
import bg from '@/assets/img/enterBg.jpg';
import bg1 from '@/assets/img/enterBg1.jpg';
import { Notify } from 'vant';
export default {
    data(){
        return {
            bg ,
            phone: this.$route.query.phone,     
        }
    },
    mounted(){
        if(this.$route.query.status == 1){
            this.bg = bg1;
        }
        this.$loca.setItem('routeItem', this.$route.path);
        Notify({ type: 'success', message: '签订成功' });
    },
    methods:{
        viewPage(){
            this.$router.push({path:'/'});
        }
    }
}
</script>
<style lang="scss" scoped>
.contract{
    width: 100%;
    height: 100%;
    background: #F6F6F6;
    position: relative;
    .bgImg{
        width: 100%;
        height: 350px;
    }
    .btn{
        background:rgba(248,169,31,1);
        color: #ffffff;
        border-radius:6px;
        width:690px;
        height: 91px;
        line-height: 91px;
        position: fixed;
        bottom: 137px;
        text-align: center;
        font-size: 39px;
        margin-left: calc((100% - 690px) / 2);
    }
}
</style>